import { inject } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivateFn, Router, RouterStateSnapshot } from '@angular/router';
import { map } from 'rxjs/operators';

import { SuperadminService } from 'app/services';

export const adminPanelGuard: CanActivateFn = (route: ActivatedRouteSnapshot, state: RouterStateSnapshot) => {
    const router: Router = inject(Router);
    const superadminService = inject(SuperadminService);

    return superadminService.getSuperadmin().pipe(
        map((superAdmin) => {
            if (superAdmin) {
                return true;
            }

            router.navigate(['/']);
            return false;
        }),
    );
};
